import JWTApi from "../libs/login/JWTApi";
import { IFood, INut } from "../shared/IFood";
import { IMeal } from "../shared/Meals";
import { IRecipe } from "../shared/Recipes";

export default class FoodApi extends JWTApi {
    static _i:FoodApi
    static get i(){
        if (!this._i) this._i = new FoodApi()
        return this._i
    }
    foods(){
        return this.api.get<IFood[]>("/1/foods").then(data => data.data)
    }
    nutrients(){
        return this.api.get<INut[]>("/1/nutrients").then(data => data.data)
    }
    recipes(){
        return this.api.get<IRecipe[]>("/1/recipes/me").then(data => data.data)
    }
    addRecipe(name:string,description:string,servings:number){
        return this.api.post<IRecipe>("/1/recipes/me", {name,description,servings}).then(data => data.data)
    }
    updateRecipe(id:string,recipe:Partial<IRecipe>){
        return this.api.post<IRecipe>("/1/recipes/me/"+id, recipe).then(data => data.data)
    }
    removeRecipe(id:string){
        return this.api.delete<any>("/1/recipes/me/"+id).then(data => data.data)
    }
    setCup2grams(id:number, grams:number){
        return this.api.put<IFood>("/1/foods/" + id + "/units/cup", grams, {headers:{"content-type":"application/json"}}).then(data => data.data)
    }
    meals(){
        return this.api.get<IMeal[]>("/1/meals/me").then(data => data.data)
    }
    addMeal(name:string){
        return this.api.post<IMeal>("/1/meals/me", {name}).then(data => data.data)
    }
    updateMeal(id:string,meal:Partial<IMeal>){
        return this.api.post<IMeal>("/1/meals/me/" + id, meal).then(data => data.data)
    }
    removeMeal(id:string){
        return this.api.delete<any>("/1/meals/me/"+id).then(data => data.data)
    }
}